/*
 * Click tracking for the two product lists on the product page:
 * "Works beautifully with" (sections/related-products-carousel.liquid) and
 * "Pairs well with" (snippets/pdp-pairs-well.liquid).
 *
 * Each list carries data-swd-list / data-swd-list-id, each product in it
 * data-swd-list-item plus its ids. A click is published as `swd_select_item`
 * through Shopify.analytics.publish; the "GA4 supplementary" custom pixel
 * (pixels/ga4-supplementary.js in the package) turns a click through into a GA4
 * select_item and an Add into a GA4 pairs_well_add.
 *
 * A click that NAVIGATES is not published on the spot: the pixel runs in a
 * sandbox that is torn down with the page, usually before it has sent anything.
 * So it is held in sessionStorage and published from the product page it
 * opened, and only if that page really is the product that was clicked — which
 * also stops a cmd-click (whose new tab inherits sessionStorage) counting twice.
 * The one-click Add does not navigate, so it is published straight away — but
 * only once the basket has accepted it: pdp-pairs-well.js fires "swd:list-add"
 * on the item after a successful add, with the line's quantity and value.
 */
(function () {
  var KEY = "swd:list-click";
  var MAX_AGE = 5 * 60 * 1000;

  function publish(payload) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === "function") {
        Shopify.analytics.publish("swd_select_item", payload);
      }
    } catch (e) {
      /* analytics must never break the storefront */
    }
  }

  function handleOf(path) {
    var m = /\/products\/([^/?#]+)/.exec(path || "");
    return m ? decodeURIComponent(m[1]).toLowerCase() : null;
  }

  function payloadFor(item, action) {
    var list = item.closest("[data-swd-list]");
    if (!list) return null;
    return {
      listName: list.getAttribute("data-swd-list"),
      listId: list.getAttribute("data-swd-list-id"),
      sourceProductId: list.getAttribute("data-source-product-id"),
      action: action,
      productId: item.getAttribute("data-product-id"),
      variantId: item.getAttribute("data-variant-id"),
      title: item.getAttribute("data-title"),
      price: Number(item.getAttribute("data-price")) || undefined,
      index: Number(item.getAttribute("data-index")) || undefined,
    };
  }

  // Capture phase, so it runs before anything that navigates or stops the click.
  document.addEventListener(
    "click",
    function (evt) {
      try {
        var target = evt.target;
        if (!target || !target.closest) return;
        var item = target.closest("[data-swd-list-item]");
        if (!item) return;

        // Published from "swd:list-add" below, once the add has succeeded.
        if (target.closest(".js-pairs-add")) return;

        var link = target.closest("a[href]");
        if (!link) return;
        var viewed = payloadFor(item, "view");
        if (!viewed) return;
        viewed.handle = handleOf(link.pathname);
        viewed.at = Date.now();
        sessionStorage.setItem(KEY, JSON.stringify(viewed));
      } catch (e) {}
    },
    true
  );

  document.addEventListener("swd:list-add", function (evt) {
    try {
      var item = evt.target && evt.target.closest && evt.target.closest("[data-swd-list-item]");
      var added = item && payloadFor(item, "add");
      if (!added) return;
      var d = evt.detail || {};
      added.quantity = d.quantity;
      added.value = d.value;
      publish(added);
    } catch (e) {}
  });

  function flush() {
    try {
      var raw = sessionStorage.getItem(KEY);
      if (!raw) return;
      sessionStorage.removeItem(KEY);
      var held = JSON.parse(raw);
      if (!held || Date.now() - held.at > MAX_AGE) return;
      if (held.handle && held.handle !== handleOf(location.pathname)) return;
      delete held.handle;
      delete held.at;
      publish(held);
    } catch (e) {}
  }

  if (document.readyState === "complete") flush();
  else window.addEventListener("load", flush);
})();
